import Actions                  from 'Redux/Actions';
import { InvoiceRepository }    from 'Domain/Repositories';
import { ofType }               from 'redux-observable';
import { from }                 from 'rxjs';
import { mergeMap, catchError } from 'rxjs/operators';
import { TEpic }                from 'Redux/Config';
import { message }              from 'antd';

export const updateInvoiceEpic: TEpic = (action$) => {
  return action$.pipe(
    ofType(Actions.updateInvoiceRequest.type),
    mergeMap(action => from(InvoiceRepository.update(action.payload.id, action.payload.formData))
      .pipe(
        mergeMap((invoice) => {
          message.success('Die Speicherung der Rechnung war erfolgreich.');

          return from([
            Actions.updateInvoiceSuccess({ invoice }),
          ]);
        }),
        catchError(error => {
          return from([
            Actions.updateInvoiceFailure({ error })
          ]);
        })
      )
    ),
  );
};
